module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_RO-699acf1f3a200f499d31e974f398fcf9.svg";